/**
 * A spoken line cut into bubble lines on its spaces, so a last word before
 * a fall reads whole over the head rather than cut at the first line's end.
 * A word longer than a line is split; past `maxLines` the last line ends
 * with an ellipsis (the full line is in the chat log).
 */
export function bubbleLines(text: string, perLine: number, maxLines: number): string[] {
  const words = text
    .trim()
    .split(/\s+/)
    .filter((word) => word.length > 0);
  const lines: string[] = [];
  let line = '';
  for (const word of words) {
    let rest = word;
    while (rest.length > perLine) {
      if (line !== '') lines.push(line);
      lines.push(rest.slice(0, perLine));
      line = '';
      rest = rest.slice(perLine);
    }
    if (line === '') line = rest;
    else if (line.length + 1 + rest.length <= perLine) line = `${line} ${rest}`;
    else {
      lines.push(line);
      line = rest;
    }
  }
  if (line !== '') lines.push(line);
  if (lines.length <= maxLines) return lines;
  const kept = lines.slice(0, maxLines);
  const last = kept[maxLines - 1] ?? '';
  kept[maxLines - 1] = `${last.slice(0, perLine - 1).trimEnd()}…`;
  return kept;
}
